import { Button } from "react-bootstrap";

export const ButtonSpinner = (props) => {
  const { buttonText } = props;
  return (
    <Button variant="primary" disabled={true}>
      {buttonText}
      <span
        className="spinner-border spinner-border-sm ms-1"
        role="status"
        aria-hidden="true"
      ></span>
    </Button>
  );
};
